/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Image_TypeInputs */

const vi_error_shop_image_type = /** @type {(inputs: Error_Shop_Image_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ nhận ảnh JPG, PNG hoặc WebP.`)
};

/**

* @param {Error_Shop_Image_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_image_type = /** @type {((inputs?: Error_Shop_Image_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Image_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_image_type(inputs)
});